export enum ProductType {
    SKU = "sku",
    CONFIGURABLE = "configurable",
    VARIABLE = "variable"
}